import _ from 'lodash'
import defaultConfig from './default'
import tpUnionLoginService from '../service/tpUnionLogin'
import { query } from 'qs'
import cookie from 'cookie'

module.exports = _.merge({}, defaultConfig, {
  name: '河北移动',
  login () {
    if (cookie.get("tper") || cookie.get("pnid")) {
      return Promise.resolve()
    }
    let { value } = query
    if (!value) {
      return Promise.reject(new Error("河北移动未登录"));
    }
    return tpUnionLoginService
      .getTpUserViewByPhoneToken(12, value)
  },
  stripBrand: false,
  hideReview: true,
  match () {
    let userAgent = navigator.userAgent
    return /hbmcc_android/.test(userAgent) || /hbmcc_ios/.test(userAgent)
  },
  init () {
    const user = require("user")
    let { value } = query
    if (value) {
      user.logout()
        .then(() => {
          this.login().catch(() => {})
        })
    }
  }
})



// WEBPACK FOOTER //
// ./src/mods/channels/hebeiyidong.js